/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockMasterSuppliers
 * @description Data access service to search master suppliers
 */
angular.module('mercury.modules.stock.supplier')
.factory('StockMasterSuppliers', ["$resource", "settings", function($resource, settings) {
  var StockMasterSuppliers = $resource(settings.mercHost + '/StockMasterSuppliers');

  /**
   * Get a list of all master suppliers
   *
   * @memberof StockMasterSuppliers
   */
  function getAll() {
    return StockMasterSuppliers.query();
  }

  return {
    getAll: getAll
  };
}]);
